/* eslint-disable */
import PbfLayer from "./pbfLayer.js";
import PbfolLayer from "./pbfolLayer.js";
import MapboxStyle from "./MapboxStyle.js";
import Polygon from "./layers/geojson/polygon.js";
import extrudedPolygon from "./layers/geojson/extrudedPolygon.js";
import waterPolygon from "./layers/geojson/waterPolygon.js";
import Polyline from "./layers/geojson/polyline.js";
import wallPolyline from "./layers/geojson/wallPolyline.js";
import Point from "./layers/geojson/point.js";
import labelPoint from "./layers/geojson/labelPoint.js";
import billboardPoint from "./layers/geojson/billboardPoint.js";
/**
 * 加载ArcGis图层
 * @param {Object} options 参数对象，包括以下：
 * @param {string} options.url 服务的网址
 * @param {string} options.id  图层id
 * @param {string} options.name 图层名称
 * @param {string} options.flyTo 是否飞跃
 * @param {string} options.show   是否显示
 * @param {array} options.layersArr
 * @param {string} options.layers 要显示的图层的逗号分隔列表，如果应显示所有图层，则未定义
 * @param {string} options.layerGroup
 * @param {Object} map 地图数据
 */
function loadArcGISLayer(options, map) {
  console.log("arcgis", options);
  //arcgis服务是通过整个服务链接地址去加载的。
  let obj = {
    url: options.url,
    id: options.id ? options.id : buildUUID(),
    name: options.name ? options.name : "ArcGis图层",
    flyTo: options.flyTo,
    show: options.show,
    layersArr: options.layersArr,
    layers: options.layers,
    layerGroup: options.layerGroup,
  };
  let arcgisLayer = new mars3d.layer.ArcGisLayer(obj);
  map.addLayer(arcgisLayer);
}
/**
 * 加载MVT图层
 * @param {Object} options 参数对象，包括以下：
 * @param {Object} options.style 图层样式
 * @param {string} options.location
 * @param {string} options.dm
 * @param {boolean} options.showStatus 图层是否显示
 * @param {string} options.id 图层id
 * @param {string} options.name 图层名称
 * @param {string} options.url 加载图层的服务地址
 * @param {string} options.queryUrl 查询图层属性的服务地址
 * @param {Object[]} options.attributes 图层属性
 * @param {Object} map 地图数据
 */
function loadMVTLayer(options, map) {
  // style可以在传进来之前就处理好（就规定要传包含特定属性的JSON参数
  let styleJSON, layerStyle;
  if (options.style && options.style.layers) {
    // 已经将需要的样式JSON文件传到了style中
    styleJSON = options.style.layers[0];
  } else if (options.style && options.style.color) {
    let rgbColor = toRGB("".concat(options.style.color));
    styleJSON = {
      type: "fill",
      paint: {
        "fill-color": `rgb(${rgbColor[0]}, ${rgbColor[1]}, ${rgbColor[2]})`,
        "fill-opacity": parseFloat("".concat(options.style.opacity)),
        "fill-outline-color": "".concat(options.style.outlineColor),
        "fill-outline-width": parseFloat("".concat(options.style.outlineWidth)),
      },
    };
  } else {
    // 如果没有传过来样式文件，那么就用默认的
    styleJSON = {
      type: "fill",
      paint: {
        "fill-color": "rgba(255,0,0,0.2)",
        "fill-opacity": "",
        "fill-outline-color": "rgba(255,0,0)",
        "fill-outline-width": "0.5",
      },
      filter: ["all"],
    };
  }

  if (options.filter) {
    styleJSON.filter = options.filter;
  }

  /* 以下代码全部提取到外部，这边只做渲染的操作
  // styleJSON.layers[0].filter.length == 1 说明filter里面只存在一个'all'
  // 这里是之前专门给首页做的一个过滤条件(区域定位)
  if(options.location){
    let locationName = options.locationName ? options.locationName : 'xzqdm'
    if(styleJSON && styleJSON.filter && styleJSON.filter.length == 1){
      // let sjxzq = options.location.substring(4) == '00'
      // if(sjxzq){
      //   styleJSON.filter[0] = 'all'
      // }else{
      //   styleJSON.filter.push(['==',['get','xzqdm'],options.location])
      // }
      var cjxzq = options.location.substring(4) === '00'; // 市级行政区代码
      var sjxzq = options.location.substring(2) === '0000'; // 省级行政区代码
      if (sjxzq) {
        styleJSON.filter.push(['>=', ['get', locationName], options.location.slice(0, 2) + '0000'])
        styleJSON.filter.push(['<=', ['get', locationName], options.location.slice(0, 2) + '9999'])
      } else if(cjxzq) {
        styleJSON.filter.push(['>=', ['get', locationName], options.location.slice(0, 4) + '00'])
        styleJSON.filter.push(['<=', ['get', locationName], options.location.slice(0, 4) + '99'])
      } else {
        if(options.name.includes('镇') && options.name.includes('行政区')){
          styleJSON.filter.push(['>=', ['get', locationName], options.location + '000'])
          styleJSON.filter.push(['<=', ['get', locationName], options.location + '999'])
        }else{
          styleJSON.filter.push(['match', ['get', locationName], options.location, true, false])
        }
      }

      //图例/饼图的显隐
      let dlbm = styleJSON.paint['fill-color'][1][1]
      if(options.dm){
        if(options.dm.length !== 0){          
          // console.log('showStatus',options.showStatus,styleJSON.layers[0].filter);
          styleJSON.filter.push(['match',['get',dlbm],options.dm,true,false])
          // options.dm.forEach(dm=>{
          //   styleJSON.layers[0].filter[2][2].push(dm)
          // })       
        }else{
          if(options.showStatus){
            // false,true 表示取反展示
            styleJSON.filter.push(['match',['get',dlbm],[],false,true])
          }else{
            styleJSON.filter.push(['match',['get',dlbm],[],true,false])
          }
        }
      }      
    }else if(styleJSON && !styleJSON.filter){
      styleJSON.filter = []
      styleJSON.filter[0] = 'all';
      // var sjxzq = options.location.substring(4) == '00';
      // if (sjxzq) {
      //   styleJSON.filter[0] = 'all';
      // } else {
      //   styleJSON.filter.push(['==', ['get', 'xzqdm'], options.location]);
      // }
      var cjxzq = options.location.substring(4) === '00'; // 市级行政区代码
      var sjxzq = options.location.substring(2) === '0000'; // 省级行政区代码
      if (sjxzq) {
        styleJSON.filter.push(['>=', ['get', locationName], options.location.slice(0, 2) + '0000'])
        styleJSON.filter.push(['<=', ['get', locationName], options.location.slice(0, 2) + '9999'])
      } else if(cjxzq) {
        styleJSON.filter.push(['>=', ['get', locationName], options.location.slice(0, 4) + '00'])
        styleJSON.filter.push(['<=', ['get', locationName], options.location.slice(0, 4) + '99'])
      } else {
        if(options.name.includes('镇') && options.name.includes('行政区')){
          styleJSON.filter.push(['>=', ['get', locationName], options.location + '000'])
          styleJSON.filter.push(['<=', ['get', locationName], options.location + '999'])
        }else{
          styleJSON.filter.push(['match', ['get', locationName], options.location, true, false])
        }
      }
    }
  }

  // 价格体系版本号的过滤
  if(options.jgtx){    
    if (styleJSON && styleJSON.filter && styleJSON.filter.length > 1) {
      styleJSON.filter.push(['match', ['get', options.jgtx], options.jgtx_id, true, false]);
    } else if (styleJSON && !styleJSON.filter) {
      styleJSON.filter = [];
      styleJSON.filter[0] = 'all';
      styleJSON.filter.push(['match', ['get', options.jgtx], options.jgtx_id, true, false]);
    }
  }

  // 行政区的过滤（定制的功能！）
  if(options.xzqdm){    
    // 如果包含百分号、*表示模糊查询：由于mapbox不太能支持模糊查询的表达式，因此可以利用320600<xzqdm<320699的方式去筛选来替代模糊查询
    if(options.xzqdm.includes('%')){
      styleJSON.filter.push(['>=',['get','xzqdm'],options.xzqdm.slice(0,6) + '000'])
      styleJSON.filter.push(['<=',['get','xzqdm'],options.xzqdm.slice(0,6) + '999'])
    }else if(options.xzqdm.includes('*县')){
      styleJSON.filter.push(['>=',['get','xzqdm'],options.xzqdm.slice(0,4) + '00'])
      styleJSON.filter.push(['<=',['get','xzqdm'],options.xzqdm.slice(0,4) + '99'])
    }else if(options.xzqdm.includes('*镇')){
      styleJSON.filter.push(['>=',['get','xzqdm'],options.xzqdm.slice(0,4) + '00000'])
      styleJSON.filter.push(['<=',['get','xzqdm'],options.xzqdm.slice(0,4) + '99999'])
    }else{
      styleJSON.filter.push(['match',['get','xzqdm'],options.xzqdm,true,false])
    }
  }

  // 首页过滤条件（委托代理）
  if(options.wtdl && options.wtdl.length !== 0){
    if(styleJSON  && styleJSON.filter.length !== 0){
      let wtdl = options.wtdl

      if(wtdl.length !== 0){
        wtdl = wtdl.map(item => {
          return item.toString()
        })

        styleJSON.filter.push(['match', ['get','wtdllx'], wtdl, true, false])          
      }
    }
  }
  */

  let tmsLayer = new PbfolLayer({
    id: options.id ? options.id : buildUUID(),
    name: options.name ? options.name : "TMS矢量切片",
    tilingScheme: new Cesium.GeographicTilingScheme(),
    url: options.url.replace("{y}", "{reverseY}"),
    queryUrl: options.queryUrl,
    style: new MapboxStyle(styleJSON),
    // style: styleJSON ? new MapboxStyle(styleJSON.layers) : new MapboxStyle(layerStyle),//多层需要在样式解析力用到for循环，很慢
    enablePickFeatures: true,
    attributes: options.attributes,
  });

  map.addLayer(tmsLayer);

  // if(options.labelShow == 1){
  //   console.log('文字标注！！！');
  //   addLabels(options,options.queryUrl,options.labelStyle,map)
  // }

  // 图层按地图缩放层级进行展示
  tmsLayer.on(mars3d.EventType.load, function (event) {
    if (styleJSON && styleJSON.minzoom && styleJSON.maxzoom) {
      if (map.level > styleJSON.minzoom && map.level < styleJSON.maxzoom) {
        // 这个区域内显示图层
        tmsLayer.opacity = 1.0;
      } else {
        // 这个区域内不显示图层
        tmsLayer.opacity = 0.0;
      }
    }
  });
  map.on(mars3d.EventType.wheel, function (event) {
    if (styleJSON && styleJSON.minzoom && styleJSON.maxzoom) {
      if (map.level > styleJSON.minzoom && map.level < styleJSON.maxzoom) {
        tmsLayer.opacity = 1.0;
      } else {
        tmsLayer.opacity = 0.0;
      }
    }
  });
}
/**
 * 加载PBF图层
 * @param {Object} options 参数对象，包括以下：
 * @param {Object} options.style 图层样式
 * @param {string} options.location
 * @param {string} options.dm
 * @param {boolean} options.showStatus 图层是否显示
 * @param {string} options.id 图层id
 * @param {string} options.name 图层名称
 * @param {string} options.url 加载图层的服务地址
 * @param {string} options.queryUrl 查询图层属性的服务地址
 * @param {Object[]} options.attributes 图层属性
 * @param {Object} map 地图数据
 */
function loadPBFLayer(options, map) {
  console.log("pbfLayers", options);
  // style可以在传进来之前就处理好（就规定要传包含特定属性的JSON参数
  var styleJSON, layerStyle;
  if (options.style.layers) {
    // 已经将需要的样式JSON文件传到了style中
    styleJSON = options.style.layers[0];
  } else if (options.style.color) {
    styleJSON = {
      type: "fill",
      paint: {
        "fill-color": `${options.style.color}`,
        "fill-opacity": `${options.style.opacity}`,
        "fill-outline-color": `${options.style.outlineColor}`,
        "fill-outline-width": `${options.style.outlineWidth}`,
      },
    };
  } else {
    // 如果没有传过来样式文件，那么就用默认的
    layerStyle = {
      type: "fill",
      paint: {
        "fill-color": "rgba(255,0,0,0.2)",
        "fill-opacity": "",
        "fill-outline-color": "rgba(255,0,0)",
        "fill-outline-width": "0.5",
      },
    };
  }
  // styleJSON.layers[0].filter.length == 1 说明filter里面只存在一个'all'
  // 这里是之前专门给首页做的一个过滤条件(区域定位) - 根据区域筛选图层数据不止在首页用到了
  if (options.location) {
    if (styleJSON && styleJSON.filter && styleJSON.filter.length == 1) {
      var sjxzq = options.location.substring(4) == "00";
      if (sjxzq) {
        styleJSON.filter[0] = "all";
      } else {
        styleJSON.filter.push(["==", ["get", "xzqdm"], options.location]);
      }

      //图例/饼图的显隐
      var dlbm = styleJSON.paint["fill-color"][1][1];
      // 不止在首页用到的话这里就需要多加一个判断（目前资产底图暂时没有展示图例的功能所以这块代码不需要走）
      if (options.dm) {
        if (options.dm.length !== 0) {
          // console.log('showStatus',options.showStatus,styleJSON.layers[0].filter);
          styleJSON.filter.push(["match", ["get", dlbm], options.dm, true, false]);
          // options.dm.forEach(dm=>{
          //   styleJSON.layers[0].filter[2][2].push(dm)
          // })
        } else {
          if (options.showStatus) {
            // false,true 表示取反展示
            styleJSON.filter.push(["match", ["get", dlbm], [], false, true]);
          } else {
            styleJSON.filter.push(["match", ["get", dlbm], [], true, false]);
          }
        }
      }
    } else if (styleJSON && !styleJSON.filter) {
      styleJSON.filter = [];
      styleJSON.filter[0] = "all";
      var sjxzq = options.location.substring(4) == "00";
      if (sjxzq) {
        styleJSON.filter[0] = "all";
      } else {
        styleJSON.filter.push(["==", ["get", "xzqdm"], options.location]);
      }
    }
  }

  // 首页过滤条件（委托代理）
  if (options.wtdl && options.wtdl.length !== 0) {
    if (styleJSON && styleJSON.filter.length !== 0) {
      var wtdl = options.wtdl;
      if (wtdl.length !== 0) {
        wtdl = wtdl.map(function (item) {
          return item.toString();
        });
        styleJSON.filter.push(["match", ["get", "wtdllx"], wtdl, true, false]);
      }
    }
  }
  var pbfLayer = new PbfolLayer({
    id: options.id ? options.id : buildUUID(),
    name: options.name ? options.name : "PBF矢量切片",
    // tilingScheme: new Cesium.GeographicTilingScheme(),
    url: options.url,
    queryUrl: options.queryUrl,
    style: styleJSON ? new MapboxStyle(styleJSON) : new MapboxStyle(layerStyle),
    // style: styleJSON ? new MapboxStyle(styleJSON.layers) : new MapboxStyle(layerStyle),//多层需要在样式解析力用到for循环，很慢
    enablePickFeatures: true,
    attributes: options.attributes,
  });
  map.addLayer(pbfLayer);

  // 图层按地图缩放层级进行展示
  pbfLayer.on(mars3d.EventType.load, function (event) {
    if (styleJSON.minzoom && styleJSON.maxzoom) {
      if (map.level > styleJSON.minzoom && map.level < styleJSON.maxzoom) {
        // 这个区域内显示图层
        pbfLayer.opacity = 1.0;
      } else {
        // 这个区域内不显示图层
        pbfLayer.opacity = 0.0;
      }
    }
  });
  map.on(mars3d.EventType.wheel, function (event) {
    if (styleJSON.minzoom && styleJSON.maxzoom) {
      if (map.level > styleJSON.minzoom && map.level < styleJSON.maxzoom) {
        pbfLayer.opacity = 1.0;
      } else {
        pbfLayer.opacity = 0.0;
      }
    }
  });
}
/**
 * 加载WMTS图层
 * @param {Object} options 参数对象，包括以下：
 * @param {string} options.url 服务地址
 * @param {string} options.layer 请求的层名
 * @param {string} options.id 图层id
 * @param {string} options.name 图层名称
 * @param {string} options.tileMatrixSetID 用于WMTS请求的TileMatrixSet的标识符
 * @param {CRS} options.crs 瓦片数据的坐标系信息
 * @param {number} options.alpha 透明度，取值范围：0.0-1.0
 * @param {string} options.pickFeaturesUrl 用于单击查看矢量对象功能的对应wms服务url
 * @param {boolean} options.flyTo 是否飞跃
 * @param {Object} map 地图数据
 */
function loadWMTSLayer(options, map) {
  let obj = {
    url: options.url,
    layer: options.layer,
    id: options.id ? options.id : buildUUID(),
    name: options.name ? options.name : "WMTS图层",
    format: "image/png",
    tileMatrixSetID: options.tileMatrixSetID ? options.tileMatrixSetID : "EPSG:4326",
    crs: options.crs ? options.crs : "EPSG:4326",
    alpha: options.alpha ? options.alpha : 1.0,
    pickFeaturesUrl: options.pickFeaturesUrl ? options.pickFeaturesUrl : "",
    flyTo: options.flyTo ? options.flyTo : false,
  };
  let wmtsLayer = new mars3d.layer.WmtsLayer(obj);
  map.addLayer(wmtsLayer);
}

/**
 * 加载WMTS图层
 * @param {Object} options 参数对象，包括以下：
 * @param {string} options.url 服务地址
 * @param {string} options.layer 请求的层名
 * @param {string} options.id 图层id
 * @param {string} options.name 图层名称
 * @param {string} options.tileMatrixSetID 用于WMTS请求的TileMatrixSet的标识符
 * @param {CRS} options.crs 瓦片数据的坐标系信息
 * @param {number} options.alpha 透明度，取值范围：0.0-1.0
 * @param {string} options.pickFeaturesUrl 用于单击查看矢量对象功能的对应wms服务url
 * @param {boolean} options.flyTo 是否飞跃
 * @param {Object} map 地图数据
 */
function loadWMSLayer(options, map) {
  let obj = {
    url: options.url,
    layers: options.layers,
    id: options.id ? options.id : buildUUID(),
    name: options.name ? options.name : "WMTS图层",
    attributes: options.attributes,
    parameters: {
      version:'1.1.1',
      request: 'GetMap',
      format: "image/png",
      transparent: true,
    },
    getCapabilities:false,
    flyTo: options.flyTo ? options.flyTo : false,
  };
  if (options.cql_filter) {
    obj.parameters.cql_filter = options.cql_filter;
  }
  let wmsLayer = new mars3d.layer.WmsLayer(obj);
  map.addLayer(wmsLayer);
}

/**
 * 加载GeoJSON图层
 * @param {Object} options 参数对象，包括以下：
 * @param {string} options.url 服务地址
 * @param {string} options.id 图层id
 * @param {string} options.name 图层名称
 * @param {string} options.dataType 数据类型
 * @param {Object} map 地图数据
 */
function loadGeoJSONLayer(options, map) {
  console.log("options", options);
  let obj;
  const {
    style: {
      isFill = false,
      color = "#ff0000",
      opacity = 1.0,
      outline = false,
      outlineColor = "#00ff00",
      outlineOpacity = 1.0,
      outlineWidth = 1.0,
      bottomHeight = 1.0,
      extrudedHeight = 1.0,
      isClampToGroud = false,
      clampGroundType = "both",
      hightlight = false,
      hightlightOpacity = 1.0,
      hightlightColor = "#3388ff",
      isFillHL = false,
      opacityHL = 1.0,
      colorHL = "#3388ff",
      outlineHL = false,
      outlineOpacityHL = 1.0,
      outlineWidthHL = 1.0,
      outlineColorHL = "#ffffff",
      isFont = false,
      content = "content",
      fontSize = 1.0,
      fontStyleC = "宋体",
      fontColor = "#ffffff",
      fontOpacity = 1.0,
      lineWidth = 1.0,
      lineWidthHL = 1.0,
      closure = false,
      diffHeight = 800,
      pixelSize = 1.0,
      horizontal = "centerH",
      vertical = "centerV",
      fontSizeHL = 1.0,
      fontStyleHLC = "宋体",
      scale = 1.0,
      scaleHL = 1.0,
      maxDistance = 9999999999999,
      minDistance = 1.0,
      baseColor = "#006ab4",
      blendColor = "#006ab4",
      frequency = 8000,
      animationSpeed = 0.03,
      amplitude = 5,
      specularIntensity = 0.8,
      baseColorHL = "#ffff00",
    } = {},
  } = options.style ? options : {};
  if (options.dataType == "polygon") {
    switch (options.styleSpecificType) {
      case "basicPolygon":
        obj = {
          id: options.id,
          url: options.url,
          name: options.name,
          isFill: isFill,
          color: color,
          opacity: opacity,
          outline: outline,
          outlineColor: outlineColor,
          outlineOpacity: outlineOpacity,
          outlineWidth: outlineWidth,
          clampToGround: isClampToGroud,
          crs: options.crs,
          flyTo: options.flyTo,
          highlight: hightlight,
          isFillHL: isFillHL,
          opacityHL: opacityHL,
          colorHL: colorHL,
          outlineHL: outlineHL,
          outlineOpacityHL: outlineOpacityHL,
          outlineWidthHL: outlineWidthHL,
          outlineColorHL: outlineColorHL,
        };
        let basePolygon = new Polygon(obj);
        basePolygon.addToMap(map);
        break;
      case "extrudedPolygon":
        obj = {
          id: options.id,
          url: options.url,
          name: options.name,
          isFill: isFill,
          color: color,
          opacity: opacity,
          outline: outline,
          outlineColor: outlineColor,
          outlineOpacity: outlineOpacity,
          outlineWidth: outlineWidth,
          clampToGround: false, // 如果该参数设为true的话则无法拉伸
          height: bottomHeight,
          diffHeight: extrudedHeight,
          crs: options.crs,
          flyTo: options.flyTo,
          highlight: hightlight,
          isFillHL: isFillHL,
          opacityHL: opacityHL,
          colorHL: colorHL,
          outlineHL: outlineHL,
          outlineOpacityHL: outlineOpacityHL,
          outlineWidthHL: outlineWidthHL,
          outlineColorHL: outlineColorHL,
        };
        let polygon = new extrudedPolygon(obj);
        polygon.addToMap(map);
        break;
      case "waterPolygon":
        obj = {
          id: options.id,
          url: options.url,
          name: options.name,
          baseColorRGB: toRGB(baseColor),
          blendColorRGB: toRGB(blendColor),
          opacity: opacity,
          frequency: frequency,
          animationSpeed: animationSpeed,
          amplitude: amplitude,
          specularIntensity: specularIntensity,
          extrudedHeight: extrudedHeight,
          bottomHeight: bottomHeight,
          colorByMaxHeight: false,
          outlineColorRGB: toRGB(outlineColor),
          outlineOpacity: outlineOpacity,
          outlineWidth: outlineWidth,
          isCesium: true,
          highlight: hightlight,
          baseColorHL: baseColorHL,
        };
        let water = new waterPolygon(obj);
        water.addToMapByCesium(map);
        break;
      default:
        break;
    }
  } else if (options.dataType == "polyline") {
    switch (options.styleSpecificType) {
      case "basicPolyline":
        obj = {
          id: options.id,
          url: options.url,
          name: options.name,
          lineWidth: lineWidth,
          color: color,
          opacity: opacity,
          clampToGround: isClampToGroud,
          highlight: hightlight,
          lineWidthHL: lineWidthHL,
          colorHL: colorHL,
          opacityHL: opacityHL,
        };
        let baseline = new Polyline(obj);
        baseline.addToMap(map);
        break;

      case "wallPolyline":
        obj = {
          id: options.id,
          url: options.url,
          name: options.name,
          closure: closure,
          diffHeight: diffHeight,
          image: options.style && options.style.textureUrl ? toUrl(options.style.textureList[0].thumbUrl) : "",
          color: color,
          opacity: opacity,
          highlight: hightlight,
          lineWidthHL: lineWidthHL,
          colorHL: colorHL,
          opacityHL: opacityHL,
        };
        let wallline = new wallPolyline(obj);
        wallline.addToMap(map);
        break;
      default:
        break;
    }
  } else if (options.dataType == "point") {
    switch (options.styleSpecificType) {
      case "basicPoint":
        obj = {
          id: options.id,
          url: options.url,
          name: options.name,
          pixelSize: pixelSize,
          color: color,
          opacity: opacity,
          outline: outline,
          outlineColor: outlineColor,
          outlineOpacity: outlineOpacity,
          outlineWidth: outlineWidth,
          maxDistance: maxDistance,
          minDistance: minDistance,
          clampToGround: isClampToGroud,
          highlight: hightlight,
          highlightOpacity: hightlightOpacity,
          highlightColor: hightlightColor,
          outlineHL: outlineHL,
          outlineOpacityHL: outlineOpacityHL,
          outlineWidthHL: outlineWidthHL,
          outlineColorHL: outlineColorHL,
        };
        let point = new Point(obj);
        point.addToMap(map);
        break;
      case "labelPoint":
        obj = {
          id: options.id,
          url: options.url,
          name: options.name,
          content: content,
          fontSize: fontSize,
          fontStyleC: fontStyleC,
          color: color,
          opacity: opacity,
          horizontal: horizontal,
          vertical: vertical,
          maxDistance: maxDistance,
          minDistance: minDistance,
          clampToGround: isClampToGroud,
          highlight: hightlight,
          opacityHL: opacityHL,
          colorHL: colorHL,
          fontSizeHL: fontSizeHL,
          fontStyleHLC: fontStyleHLC,
        };
        let label = new labelPoint(obj);
        label.addToMap(map);
        break;
      case "picturePoint":
        obj = {
          id: options.id,
          url: options.url,
          name: options.name,
          imageUrl: options.style && options.style.textureList ? toUrl(options.style.textureList[0].thumbUrl) : "",
          scale: scale,
          maxDistance: maxDistance,
          minDistance: minDistance,
          clampToGround: isClampToGroud,
          highlight: hightlight,
          scaleHL: scaleHL,
        };
        let billboard = new billboardPoint(obj);
        billboard.addToMap(map);
        break;
      default:
        break;
    }
  } else if (options.dataType == "2DModel") {
    // datatype == 'model' iswater?
    obj = {
      url: options.url,
      name: options.name ? options.name : "GeoJSON拉伸图层",
      opacity: 0.7,
      amplitude: 5.0,
      animationSpeed: 0.02,
      bottomHeight: 0.0,
      extrudedHeight: 100,
      frequency: 8000,
      outlineOpacity: 0.6,
      specularIntensity: 0.8,
      colorByMaxHeight: 20.0,
      isCesium: true,
    };
    if (options.isWater) {
      waterByCesium(options, map);
    } else {
      // 加载白膜的代码
      obj.symbol = {
        type: "polygonC",
        styleOptions: {
          color: color ? color : "#ffffff",
          opacity: opacity !== null ? opacity : 1.0,
          outline: outline || false,
          outlineColor: outlineColor ? outlineColor : "#ffffff",
          outlineOpacity: outlineOpacity !== null ? outlineOpacity : 1.0,
          outlineWidth: outlineWidth !== null ? outlineWidth : 1.0,
          highlight: {
            type: "click",
            opacity: options.highlight && options.highlight.opacity !== null ? options.highlight.opacity : 1.0,
            color: options.highlight && options.highlight.color ? options.highlight.color : "#3388ff",
            outline: options.highlight && options.highlight.outline ? options.highlight.outline : true,
            outlineWidth:
              options.highlight && options.highlight.outlineWidth !== null ? options.highlight.outlineWidth : 3,
            outlineColor:
              options.highlight && options.highlight.outlineColor ? options.highlight.outlineColor : "#fffffff",
          },
        },
        callback: function (attr) {
          let diffHeight = attr[options.heightAttr];
          let color = options.colorArr ? attr[options.colorAttr] : "#ffffff";
          return {
            height: 0,
            diffHeight,
            color,
          };
        },
      };
    }
  }
  obj.allowDrillPick = true;
}

/**
 * 加载3dteilse图层
 * @param {Object} options 参数对象，包括以下：
 * @param {string} options.url 服务地址
 * @param {string} options.id 图层id
 * @param {string} options.name 图层名称
 * @param {string} options.isNonOblique 是否为倾斜摄影（true-倾斜摄影；false-白模）
 * @param {string} options.style 样式
 * @param {Object} map 地图数据
 */
function load3dTilesLayer(options, map) {
  let obj = {
    name: options.name ? options.name : "3dtile图层",
    id: options.id ? options.id : buildUUID(),
    url: options.url,
    flyTo: options.flyTo ? options.flyTo : false,
  };

  if (options.isNonOblique) {
    // 加载倾斜摄影使用该配置
    obj.maximumScreenSpaceError = 16;
    obj.maximumMemoryUsage = 512;
    obj.skipLevelOfDetail = true;
    obj.preferLeaves = true;
    obj.enableDebugWireframe = true; //是否可以进行三角网的切换展示
    obj.progressiveResolutionHeightFraction = 0.5; //【重要】 数值偏于0能够让初始加载变得模糊
    obj.dynamicScreenSpaceError = true; // true时会在真正的全屏加载完之后才清晰化模型
    obj.preloadWhenHidden = true; //tileset.show是false时，也去预加载数据
    if (options.style && options.style.hightlight) {
      obj.highlight = {
        type: mars3d.EventType.click, // 单击高亮
        outlineEffect: options.style.outlineHL, // 采用OutlineEffect方式来高亮
        color: options.style.outlineHL ? options.style.outlineColorHL : options.style.hightlightColor,
        width: options.style.outlineWidthHL,
      };
    }
  } else {
    let color = options.style && options.style.color ? toRGB(options.style.color) : [16, 119, 209];
    console.log("color", color);
    let rgbColor = `rgba(${color[0]},${color[1]},${color[2]},${options.style.opacity})`;
    console.log("rgb", rgbColor);
    // 加载类似白模模型
    obj.maximumScreenSpaceError = 1;
    obj.style = {
      color: {
        conditions: [["true", rgbColor]],
      },
    };
    if (options.style && options.style.hightlight) {
      obj.highlight = {
        type: mars3d.EventType.click, // 单击高亮
        outlineEffect: options.style.outlineHL, // 采用OutlineEffect方式来高亮
        color: options.style.outlineHL ? options.style.outlineColorHL : options.style.hightlightColor,
        width: options.style.outlineWidthHL,
      };
    }
    obj.enableDebugWireframe = options.style && options.style.transTriangle ? options.style.transTriangle : false; // 是否可以进行三角网的切换显示 - 用于调试
  }
  let tiles3dLayer = new mars3d.layer.TilesetLayer(obj);

  map.addLayer(tiles3dLayer);
}

/**
 * 以下为加载影像的代码
 */

/**
 * 加载ArcGISTile影像
 * @param {Object} options 参数对象，包括以下：
 * @param {string} options.url 服务地址
 * @param {string} options.id 图层id
 * @param {string} options.name 图层名称
 * @param {Object} map 地图数据
 */
function loadArcGISTile(options, map) {
  let obj = {
    url: options.url,
    id: options.id ? options.id : buildUUID(),
    name: options.name ? options.name : "ArcGIS瓦片影像",
  };
  let arcgisTile = new mars3d.layer.ArcGisLayer(obj);
  map.addLayer(arcgisTile);
}

/**
 * 加载xyz影像
 * @param {Object} options 参数对象，包括以下：
 * @param {string} options.url 服务地址(需要包含{z}{x}{y})
 * @param {string} options.id 图层id
 * @param {string} options.name 图层名称
 * @param {string} options.subdomains 占位符（用于url模板中的{s}）
 * @param {Object} map 地图数据
 */
function loadXYZTile(options, map) {
  let obj = {
    url: options.url,
    id: options.id ? options.id : buildUUID(),
    name: options.name ? options.name : "XYZ影像",
    subdomains: options.subdomains ? options.subdomains : "",
  };
  let xyzTile = new mars3d.layer.XyzLayer(obj);
  map.addLayer(xyzTile);
}
/**
 * 加载天地图影像
 * @param {Object} options 参数对象，包括以下：
 * @param {string} options.url 服务地址(如：)
 * @param {string} options.id 图层id
 * @param {string} options.name 图层名称
 * @param {string} options.layer 图层类型(
 * vec_d电子图层
 * vec_z电子注记
 * vec_e: 电子注记英文
 * img_d: 卫星影像
 * img_z: 影像注记
 * img_e: 影像注记英文
 * ter_d: 地形渲染图
 * ter_z: 地形渲染图注记
 * xzqh: 行政区划界线)
 * @param {string | Array} options.subdomains 占位符（用于url模板中的{s}）
 * @param {Object} map 地图数据
 */
function loadTdtTile(options, map) {
  let obj = {
    url: options.url,
    id: options.id ? options.id : buildUUID(),
    name: options.name ? options.name : "天地图影像",
    layer: options.layer ? options.layer : "vec_d",
    subdomains: options.subdomains ? options.subdomains : "",
    key: options.token ? options.token : mars3d.Token.tiandituArr,
  };
  let tdtTile = new mars3d.layer.TdtLayer(obj);
  map.addLayer(tdtTile);
}

/**
 * 加载高德影像
 * @param {Object} options 参数对象，包括以下：
 * @param {string} options.url 服务地址(如：)
 * @param {string} options.id 图层id
 * @param {string} options.name 图层名称
 * @param {string} options.layer 图层类型(
 * vec电子图层
 * img_d: 卫星影像
 * img_z: 影像注记
 * time: 实时路况信息)
 * @param {string | Array} options.subdomains 占位符（用于url模板中的{s}）
 * @param {Object} map 地图数据
 */
function loadGaodeTile(options, map) {
  let obj = {
    url: options.url,
    id: options.id ? options.id : buildUUID(),
    name: options.name ? options.name : "高德影像",
    layer: options.layer ? options.layer : "vec",
    subdomains: options.subdomains ? options.subdomains : "",
  };
  let gaodeTile = new mars3d.layer.GaodeLayer(obj);
  map.addLayer(gaodeTile);
}

/**
 * 加载腾讯影像
 * @param {Object} options 参数对象，包括以下：
 * @param {string} options.url 服务地址(如：)
 * @param {string} options.id 图层id
 * @param {string} options.name 图层名称
 * @param {string} options.layer 图层类型(
 * vec电子图层
 * img_d: 卫星影像
 * img_z: 影像注记
 * custom: 地形渲染图)
 * @param {string} options.style 当layer为custom时可选，3 - 灰白地图。4 - 暗色地图
 * @param {string | Array} options.subdomains 占位符（用于url模板中的{s}）
 * @param {Object} map 地图数据
 */
function loadTencentTile(options, map) {
  let obj = {
    url: options.url,
    id: options.id ? options.id : buildUUID(),
    name: options.name ? options.name : "腾讯影像",
    layer: options.layer ? options.layer : "vec",
    style: options.style ? options.style : "3",
    subdomains: options.subdomains ? options.subdomains : "",
  };
  let tencentTile = new mars3d.layer.TencentLayer(obj);
  map.addLayer(tencentTile);
}

function toUrl(base64img) {
  let blob = pngBase64ToBlob(base64img);
  let url = URL.createObjectURL(blob);
  return url;
}
function pngBase64ToBlob(urlData) {
  try {
    var arr = urlData.split(",");
    var mime = arr[0].match(/:(.*?);/)[1] || type;
    // 去掉url的头，并转化为byte
    var bytes = window.atob(arr[1]);
    // 处理异常,将ascii码小于0的转换为大于0
    var ab = new ArrayBuffer(bytes.length);
    // 生成视图（直接针对内存）：8位无符号整数，长度1个字节
    var ia = new Uint8Array(ab);
    for (var i = 0; i < bytes.length; i++) {
      ia[i] = bytes.charCodeAt(i);
    }
    return new Blob([ab], {
      type: mime,
    });
  } catch (e) {
    var ab = new ArrayBuffer(0);
    return new Blob([ab], {
      type: type,
    });
  }
}
/**
 * 生成随机数
 * @returns {string}
 */
function buildUUID() {
  const hexList = [];
  for (let i = 0; i <= 15; i++) {
    hexList[i] = i.toString(16);
  }
  let uuid = "";
  for (let i = 1; i <= 36; i++) {
    if (i === 9 || i === 14 || i === 19 || i === 24) {
      uuid += "-";
    } else if (i === 15) {
      uuid += 4;
    } else if (i === 20) {
      uuid += hexList[(Math.random() * 4) | 8];
    } else {
      uuid += hexList[(Math.random() * 16) | 0];
    }
  }
  return uuid;
}
/**
 * 将十六进制颜色转换为RGB数组
 * @returns {array}
 */
function toRGB(inColor) {
  // 16进制颜色值的正则
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  // 把颜色值变成小写
  var color = inColor.toLowerCase();
  if (reg.test(color)) {
    // 如果只有三位的值，需变成六位，如：#fff => #ffffff
    if (color.length === 4) {
      var colorNew = "#";
      for (var i = 1; i < 4; i += 1) {
        colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
      }
      color = colorNew;
    }
    // 处理六位的颜色值，转为RGB
    var colorChange = [];
    for (var i = 1; i < 7; i += 2) {
      colorChange.push(parseInt("0x" + color.slice(i, i + 2)));
    }
    return colorChange;
  } else {
    return color;
  }
}
function addLabels(options, url, labelStyle, map) {
  // console.log('url',url,labelStyle);
  let name = labelStyle.labelCode.toLowerCase();
  fetch(url)
    .then((response) => response.json())
    .then((data) => {
      let pointCenter = [];
      let centerArr = [];
      let labelCollection = new Cesium.LabelCollection();
      labelCollection.name = options.name;
      map.scene.primitives.add(labelCollection);
      // let labels = map.scene.primitives.add(new Cesium.LabelCollection())
      // let graphicLayer = new mars3d.layer.GraphicLayer()
      // map.addLayer(graphicLayer)
      // console.log('data',data.features);
      if (
        data.features[0].geometry.type.includes("Polygon") ||
        data.features[0].geometry.type.includes("MultiPolygon")
      ) {
        for (let i = 0; i < data.features.length; i++) {
          let coords = data.features[i].geometry.coordinates[0];
          // let polygon = turf.polygon(coords)
          let polygon = null;
          coords.length && (polygon = turf.polygon(coords));
          let center = turf.centroid(polygon);
          let attr = data.features[i].properties[name];
          pointCenter.push(center);
          centerArr.push(attr);
        }

        // let styleJSON = JSON.parse(options.layerStyle)
        let color = toRGB(labelStyle.labelColor);
        //  console.log('point and label',pointCenter,centerArr);
        //  labelSize(map.level)

        for (let j = 0; j < pointCenter.length; j++) {
          let center = pointCenter[j].geometry.coordinates;
          // const graphic = new mars3d.graphic.LabelPrimitive({
          //   name: options.name,
          //   position: new mars3d.LngLatPoint(_center[0],_center[1]),
          //   style: {
          //     text: centerArr[j],
          //     font_size: labelStyle.size,
          //     color: "#ffff00",
          //     scaleByDistance:true,
          //     scaleByDistance_far:labelStyle.maxDistance,
          //     scaleByDistance_farValue:0,
          //     scaleByDistance_near:labelStyle.minDistance,
          //     scaleByDistance_nearValue:1,
          //     clampToGround: true
          //   },
          // })
          // graphicLayer.addGraphic(graphic)
          let labelParams = {
            //  id:labelStyle.labelId,
            text: centerArr[j],
            position: new Cesium.Cartesian3.fromDegrees(center[0], center[1], 0),
            font: `${labelStyle.size}px ${labelStyle.family}`,
            fillColor: new Cesium.Color(color[0] / 255.0, color[1] / 255.0, color[2] / 255.0, 1.0),
            outlineColor: Cesium.Color.BLACK, //边线好像不起作用
            outlineWidth: 1.5,
            style: Cesium.LabelStyle.FILL,
            //  scaleByDistance:new Cesium.NearFarScalar(1,1,99999999,2)
            scaleByDistance: new Cesium.NearFarScalar(labelStyle.minDistance, 1, labelStyle.maxDistance, 0),
          };
          //  console.log('参数',labelParams);
          //  labels.add(labelParams)
          labelCollection.add(labelParams);
        }
      } else if (data.features[0].geometry.type.includes("Point")) {
        let features = data.features;
        let color = toRGB(labelStyle.labelColor);
        for (let i = 0; i < data.features.length; i++) {
          let labelParams = {
            text: data.features[i].properties[name],
            position: new Cesium.Cartesian3.fromDegrees(
              features[i].geometry.coordinates[0],
              features[i].geometry.coordinates[1],
              0
            ),
            font: `${labelStyle.size}px ${labelStyle.family}`,
            fillColor: new Cesium.Color(color[0] / 255.0, color[1] / 255.0, color[2] / 255.0, 1.0),
            scaleByDistance: new Cesium.NearFarScalar(1, 1, 99999999, 2),
          };
          labels.add(labelParams);
        }
      }
    });
}

/**
 * 加载水面
 * @param {string} url 服务地址
 * @param {Object} map 地图数据
 */
function waterByCesium(options, map) {
  const baseColorRGB = options.style && options.style.baseColor ? toRGB(options.style.baseColor) : null;
  const blendColorRGB = options.style && options.style.blendColor ? toRGB(options.style.blendColor) : null;
  const outlineColorRGB = options.style && options.style.outlineColor ? toRGB(options.style.outlineColor) : null;
  //使用Cesium
  fetch(options.url)
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      console.log("water", data);
      var instances = [];
      var lineGeom = [];
      var primitiveCollection = new Cesium.PrimitiveCollection();
      var scene = map.scene;
      var points = [];
      var ids = [];
      var maxHeights = [];
      var minHeights = [];
      scene.globe.enableLighting = false;
      for (var i = 0; i < data.features.length; i++) {
        var riverPointArr = data.features[i].geometry.coordinates[0][0];
        var riverPoint = [];
        for (var j = 0; j < riverPointArr.length; j++) {
          riverPoint.push(riverPointArr[j][0]);
          riverPoint.push(riverPointArr[j][1]);
        }
        ids.push(data.features[i].id);
        points.push(riverPoint);
        maxHeights.push(
          data.features[i].properties.maxhight
            ? data.features[i].properties.maxhight
            : options.style && options.style.extrudedHeight
            ? options.style.extrudedHeight
            : 100
        );
        minHeights.push(
          data.features[i].properties.minhight
            ? data.features[i].properties.minhight
            : options.style && options.style.bottomHeight
            ? options.style.bottomHeight
            : 0
        );
      }
      for (var k = 0; k < points.length; k++) {
        var polygon1 = new Cesium.PolygonGeometry({
          polygonHierarchy: new Cesium.PolygonHierarchy(Cesium.Cartesian3.fromDegreesArray(points[k])),
          extrudedHeight: maxHeights[k],
          // 水面高度
          height: minHeights[k],
          // 底部高度
          vertexFormat: Cesium.EllipsoidSurfaceAppearance.VERTEX_FORMAT,
          allowPicking: true,
        });
        var outlineGeometry = new Cesium.PolygonOutlineGeometry({
          polygonHierarchy: new Cesium.PolygonHierarchy(Cesium.Cartesian3.fromDegreesArray(points[k])),
          extrudedHeight: maxHeights[k],
          // 水面高度
          height: minHeights[k],
          // 底部高度
          vertexFormat: Cesium.EllipsoidSurfaceAppearance.VERTEX_FORMAT,
          allowPicking: true,
        });
        var geometry = new Cesium.GeometryInstance({
          geometry: polygon1,
          attributes: {
            color: Cesium.ColorGeometryInstanceAttribute.fromColor(new Cesium.Color(1, 1, 0, 0.6)),
          },
          id: ids[k],
        });
        var lgeometry = new Cesium.GeometryInstance({
          geometry: outlineGeometry,
          attributes: {
            color: options.isWater
              ? maxHeights[k] > 20
                ? Cesium.ColorGeometryInstanceAttribute.fromColor(new Cesium.Color(1.0, 0.0, 0.0, 1.0))
                : Cesium.ColorGeometryInstanceAttribute.fromColor(new Cesium.Color(0.0, 1.0, 0.0, 1.0))
              : outlineColorRGB
              ? Cesium.ColorGeometryInstanceAttribute.fromColor(
                  new Cesium.Color(
                    outlineColorRGB[0] / 255.0,
                    outlineColorRGB[1] / 255.0,
                    outlineColorRGB[2] / 255.0,
                    options.style.outlineOpacity
                  )
                )
              : Cesium.ColorGeometryInstanceAttribute.fromColor(new Cesium.Color(1, 1, 0, 0.6)),
            // color: outlineColorRGB ? Cesium.ColorGeometryInstanceAttribute.fromColor(new Cesium.Color(outlineColorRGB[0] / 255.0, outlineColorRGB[1] / 255.0, outlineColorRGB[2] / 255.0, options.style.outlineOpacity)) : Cesium.ColorGeometryInstanceAttribute.fromColor(new Cesium.Color(1, 1, 0, 0.6))
            // show: new Cesium.ShowGeometryInstanceAttribute(true),
          },
        });
        instances.push(geometry);
        lineGeom.push(lgeometry);
      }
      var river1 = new Cesium.Primitive({
        geometryInstances: instances,
        releaseGeometryInstances: false,
        appearance: new Cesium.EllipsoidSurfaceAppearance(),
        show: true,
      });
      var river2 = new Cesium.Primitive({
        geometryInstances: lineGeom,
        appearance: new Cesium.PerInstanceColorAppearance({
          flat: true,
        }),
      });
      var riverMaterial = new Cesium.Material({
        fabric: {
          type: "Water",
          uniforms: {
            baseWaterColor: baseColorRGB
              ? new Cesium.Color(
                  baseColorRGB[0] / 255.0,
                  baseColorRGB[1] / 255.0,
                  baseColorRGB[2] / 255.0,
                  options.style.opacity
                )
              : new Cesium.Color(0, 0.4, 0.7, 0.7),
            blendColor: blendColorRGB
              ? new Cesium.Color(
                  blendColorRGB[0] / 255.0,
                  blendColorRGB[1] / 255.0,
                  blendColorRGB[2] / 255.0,
                  options.style.opacity
                )
              : new Cesium.Color(0, 0.4, 0.7, 0.7),
            normalMap: "img/textures/waterNormals.jpg",
            frequency: options.style && options.style.frequency ? options.style.frequency : 8000.0,
            animationSpeed: options.style && options.style.animationSpeed ? options.style.animationSpeed : 0.02,
            amplitude: options.style && options.style.amplitude ? options.style.amplitude : 5.0,
            specularIntensity: options.style && options.style.specularIntensity ? options.style.specularIntensity : 0.8,
          },
        },
      });
      console.log("material", riverMaterial);
      river1.appearance.material = riverMaterial;
      primitiveCollection.add(river1);
      primitiveCollection.add(river2);
      primitiveCollection._zIndex = 1;
      primitiveCollection.id = options.id;
      primitiveCollection.name = "水体模型";
      scene.primitives.add(primitiveCollection);
    });
}

export {
  loadArcGISLayer,
  loadMVTLayer,
  loadPBFLayer,
  loadWMTSLayer,
  loadWMSLayer,
  loadArcGISTile,
  loadGeoJSONLayer,
  load3dTilesLayer,
  loadXYZTile,
  loadTdtTile,
};
